import React from 'react';
import { useWindowDimensions } from 'react-native';
import MapView from 'react-native-maps';
import styled from 'styled-components/native';

import Divider from '@src/components/Divider';
import Image from '@src/components/Image';
import Separator from '@src/components/Separator';
import { H2 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

import useLocationProfile from './useLocationProfile';

type Props = {
  id: string;
};

const Container = styled.View``;

const Cover = styled(Image)`
  width: 100%;
  height: 250px;
`;

const Content = styled.View`
  padding: ${padding}px;
`;

const Map = styled(MapView)`
  width: 100%;
  height: 250px;
`;

// @ts-ignore
const Marker = MapView.Marker;

const Heading: React.FC<Props> = ({ id }) => {
  const dimensions = useWindowDimensions();
  const locationProfile = useLocationProfile(id);

  return (
    <Container style={{ width: dimensions.width }}>
      <Cover source={locationProfile.data?.cover?.source ?? { uri: '' }} />
      <Content>
        <H2>{locationProfile.data?.name}</H2>
      </Content>
      <Map
        // @ts-ignore
        options={{ scrollwheel: false }}
        initialRegion={{
          latitude: 0,
          longitude: 0,
          latitudeDelta: 0.0922,
          longitudeDelta: 0.0421,
        }}
      >
        <Marker coordinate={{ latitude: 0, longitude: 0 }} />
      </Map>
      <Separator />
      <Divider />
      <Separator />
    </Container>
  );
};

export default React.memo(Heading);
